import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';
// import logo from '../../assets/logo.png'; // adjust path
import logo from '../../Assets/images/banner-logo.png'

const PrivacyPageDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="privacy-header">
        <img
          src={logo}
          alt="Site Inspect Logo"
          className="privacy-logo"
          onClick={() => navigate('/')}
        />
        <h1>Privacy Policy</h1>
      </header>

      {/* Content */}
      <div className="privacy-content">
        <p className="effective-date">
          <strong>Effective Date:</strong> January 2026
        </p>

        <p>
          <strong>Site Inspect</strong> (“we”, “our”, or “us”) is committed to protecting your
          privacy. This Privacy Policy explains how information is collected, used,
          stored, and disclosed when using the Site Inspect mobile application
          (“the App”).
        </p>

        <p>
          Site Inspect is a professional inspection application used by authorised
          inspectors to record property defects and generate inspection reports for
          clients.
        </p>

        <h2>1. Information We Collect</h2>

        <h3>a. Account Information</h3>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>User role (e.g. inspector)</li>
          <li>Organisation details</li>
        </ul>

        <h3>b. Inspection Data</h3>
        <ul>
          <li>Property inspection records</li>
          <li>Defect descriptions and notes</li>
          <li>Photos and attachments uploaded by users</li>
          <li>Generated inspection reports</li>
        </ul>

        <h3>c. Device and Usage Information</h3>
        <ul>
          <li>Device type and operating system</li>
          <li>App usage information</li>
          <li>Error and crash logs</li>
        </ul>

        <h2>2. How We Use Information</h2>
        <ul>
          <li>Enable inspectors to create and manage inspections</li>
          <li>Generate inspection reports for clients</li>
          <li>Provide secure access to inspection records</li>
          <li>Maintain and improve app performance</li>
          <li>Provide technical support</li>
        </ul>

        <p>
          We do not use collected data for advertising or marketing to end users.
        </p>

        <h2>3. Data Sharing and Disclosure</h2>
        <p>We do not sell or rent personal information.</p>
        <ul>
          <li>With the organisation managing your account</li>
          <li>With authorised users in the same organisation</li>
          <li>With trusted service providers under confidentiality obligations</li>
          <li>Where required by law</li>
        </ul>

        <h2>4. Data Storage and Security</h2>
        <p>
          We take reasonable technical and organisational measures to protect
          information against unauthorised access, loss, or misuse.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          Information is retained only as long as necessary or as required by law.
          Data may be deleted upon request by the account-owning organisation.
        </p>

        <h2>6. User Access and Control</h2>
        <p>
          Access is restricted to authorised users. Users may request access to or
          correction of personal information through their organisation or support.
        </p>

        <h2>7. Third-Party Services</h2>
        <p>
          The App may rely on third-party services for hosting, analytics, or error
          reporting, all operating under applicable privacy obligations.
        </p>

        <h2>8. Children’s Privacy</h2>
        <p>
          Site Inspect is intended for professional use only and is not designed
          for children under the age of 13.
        </p>

        <h2>9. Changes to This Privacy Policy</h2>
        <p>
          This policy may be updated from time to time. Updates will be published
          on this page with a revised effective date.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          <strong>Email:</strong> support@sdss.net.au <br />
          <strong>Website:</strong>{' '}
          <a href="https://siteinspect.sdss.net.au" target="_blank" rel="noreferrer">
            https://siteinspect.sdss.net.au
          </a>
        </p>

        <p className="acknowledgement">
          By using the Site Inspect application, you acknowledge that you have read
          and understood this Privacy Policy.
        </p>
      </div>

      {/* Footer */}
      <footer className="privacy-footer">
        © {new Date().getFullYear()} Site Inspect. All rights reserved.
      </footer>
    </div>
  );
};

export default PrivacyPageDetail;
